// extracted by mini-css-extract-plugin
export default {"contentContainer":"ChangeContent_contentContainer__o11rg"};